<template>
  <!-- 公司项目 -->
  <div id="enterprise-card5">
    <div class="enterprise-card5-list">
      <div
        class="box-card"
        v-for="(item, index) in table.tableData"
        :key="index"
      >
        <div class="box-card-content">
          <div class="box-card-content-title">
            <div class="title">{{ item.title }}</div>
            <div class="salary">{{ item.salaryStr }}</div>
          </div>
          <div class="box-card-content-tag">
            <div class="tag" v-if="item.baseStr">{{ item.baseStr }}</div>
            <div class="tag" v-if="item.education">{{ item.education }}</div>
            <div class="tag" v-if="item.zpnumberStr">
              {{ item.zpnumberStr }}
            </div>
          </div>
          <el-popover placement="top-start" trigger="hover">
            <pre
              style="width: 480px; max-height: 150px ; overflow-y: auto;"
              v-text="item.description"
            ></pre>
            <div slot="reference" class="box-card-content-des">
              <pre style="color: #777e95;" v-text="item.description"></pre>
            </div>
          </el-popover>
          <div class="box-card-content-resource">
            <span>来源: {{ item.source }}</span>
            <span>发布日期: {{ item.zpdate }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="enterprise-card5-pagination">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="table.pageData.pageIndex"
        :page-size="table.pageData.pageSize"
        layout="prev, pager, next"
        :total="table.pageData.totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    table: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    handleCurrentChange(val) {
      console.log("当前页: ", val);
      this.$emit("handleCurrentChange", this.table);
    },
  },
};
</script>

<style lang="less" scoped>
#enterprise-card5 {
  .enterprise-card5-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .box-card {
      width: 49%;
      margin-bottom: 10px;
      padding: 20px;
      box-sizing: border-box;
      background-image: linear-gradient(217deg, #ffefdecc, #fff 50%);
      border-radius: 4px;
      box-shadow: 0 0 8px #0000001a;
      .box-card-content {
        text-align: left;

        .box-card-content-title {
          display: flex;
          justify-content: space-between;
          font-weight: 500;
          .title {
            font-size: 18px;
            line-height: 18px;
            color: #111a34;
          }
          .salary {
            color: #ff8200;
            font-weight: 500;
            font-size: 20px;
            line-height: 20px;
            letter-spacing: 0;
          }
        }
        .box-card-content-tag {
          display: flex;
          font-size: 12px;
          margin-top: 3px;
          color: #777e95;
          margin: 12px 0 16px;
          .tag {
            display: inline-block;
            height: 16px;
            padding: 0 4px;
            line-height: 16px;
            background: #eceef3;
            border-radius: 2px;
            margin-right: 5px;
          }
        }
        .box-card-content-des {
          height: 88px;
          line-height: 22px;
          max-height: 88px;
          font-size: 14px;
          margin-top: 12px;
          color: #777e95;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
        }
        .box-card-content-resource {
          font-size: 14px;
          margin-top: 16px;
          color: #c3c8da;
        }
      }
    }
  }
  .enterprise-card5-pagination {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
}
</style>
